(function(){
  angular.module('EdxClassroomReportModule')
    .directive('edxStudentAlerts', function() {
      return {
        restrict: 'E',
        scope: {
          edxStudentAlerts: '='
        },
        templateUrl: '/resources/components/report/classroom/at-a-glance/student-alerts.directive.html',
        controller: [
          'edxStudentAlertsService',
          StudentAlertsController
        ],
        controllerAs: 'vm',
        bindToController: true
      };
    });

  function StudentAlertsController(edxStudentAlertsService) {
    var vm = this;
    vm.learningAlerts = [];
    vm.usageAlerts = [];
    vm.enableUsageAlerts = false;    // For the first EFP, we want to hide usage alerts until we figure out messaging.
    this.$onInit = function() {
      _partitionAlerts(vm.edxStudentAlerts);
    };

    // noinspection UnnecessaryReturnStatementJS
    return;

    function _partitionAlerts(alerts) {
      // Sort alerts into learning and usage categories
      var partitions = _.groupBy(alerts, function(alert) {
        return alert.category;
      });
      vm.learningAlerts = partitions[edxStudentAlertsService.ALERT_CATEGORIES.LEARNING] || [];
      vm.usageAlerts = _.filter(partitions[edxStudentAlertsService.ALERT_CATEGORIES.USAGE] || []);

      // Remove from usage alerts students appearing in learning alerts
      var learning = {};
      _.forEach(vm.learningAlerts, function(student){
        learning[student.id] = student.id;
      });

      vm.usageAlerts = _.filter(vm.usageAlerts, function(student){
        return !learning[student.id];
      });

    }
  }

})();
